import { NgbDate } from "@ng-bootstrap/ng-bootstrap";
import { BaseDataService } from "yt-ng-framework";
import { map } from "rxjs/operators";
import { AngazovanjeRo } from "../kad/angazovanje-ro/angazovanje-ro";

export function kadblDaLiJeOdDatumaNaNeodredjenoOK(datum:NgbDate, odDatuma:NgbDate):boolean{
    if (datum.before(odDatuma) || datum.equals(odDatuma))
        return true;
    return false
}

export function kadblDaLiJeDoDatumaNaNeodredjenoOK(doDatuma:NgbDate):boolean{
    if (doDatuma==null)
        return true;
    return false
}

export function kadblDaLiJeOdDatumaNaOdredjenoOK(datum:NgbDate, odDatuma:NgbDate):boolean{
    if (datum.before(odDatuma) || datum.equals(odDatuma))
        return true;
    return false
}

export function kadblDaLiJeDoDatumaNaOdredjenoOK(datum:NgbDate, odDatuma:NgbDate, doDatuma:NgbDate):boolean{
    if (doDatuma==null)
        return false;
    else
        if ((datum.before(doDatuma) || datum.equals(doDatuma))
            && (odDatuma.before(doDatuma) || odDatuma.equals(doDatuma)))
            return true;
    return false;
}

export function kadblDaLiJeZaNepunoRadnoVremePrcAngOK(prcAng:number):boolean{
    if (prcAng<100 && prcAng>0)
        return true;
    return false;
}

export function kadblDaLiJeDefinisanaVisinaZaradeOK(
    koeficijent: number
    , netoZarada: number
    , brutoZarada: number
    , netoCenaSata: number
    , brutoCenaSata: number
):boolean{
    if (koeficijent<=0
        && netoZarada<=0
        && brutoZarada<=0
        && netoCenaSata<=0
        && brutoCenaSata<=0
    )
        return false;
    return true;
}

export function kadblDajPodrazumevaniNedeljniFondSatiZaPrcAng(prcAng:number):number{
    if (prcAng==0)
        return 0;
    if (prcAng>=100)
        return 40;
    return Math.round(prcAng/100*40);
}

export function kadblDaLiJeZaPunoRadnoVremePrcAngOK(prcAng:number):boolean{
    if (prcAng>=100)
        return true;
    return false;
}


export function kadblDajBrojZaNoviDokument(bds: BaseDataService, podVrstaDokumentaStavkaID: Number, datum: NgbDate){
    return bds.GetData("AngazovanjeRo", "KreirajBrojDokumenta", {
        PodVrstaDokumentaStavkaID: podVrstaDokumentaStavkaID,
        Datum: datum
      })
      .pipe(map(data => {
          return data
      })); 
}

export function kadblDaLiJeDatumPoslePrethodnihDokumenataZaUgovor(vezanaDokumena: Array<AngazovanjeRo>, datumDokumenta: NgbDate){

}